import LoanDetails from 'features/payOverTime/screens/LoanDetails/LoanDetails';
import React from 'react';

export default function Page() {
  return <LoanDetails />;
}
